// API Configuration
// Do NOT import dotenv in the browser bundle; CRA injects env at build time
const resolveBaseUrl = () => {
  try {
    // CRA build-time env
    const fromEnv = process.env.REACT_APP_BACKEND_URL;
    // Optional runtime-injected window _env_
    const fromWindow = (typeof window !== 'undefined' && window._env_ && window._env_.REACT_APP_BACKEND_URL) ? window._env_.REACT_APP_BACKEND_URL : undefined;
    const url = (fromEnv || fromWindow || '').toString();
    const trimmed = url.replace(/\/$/, '');
    try {
      // eslint-disable-next-line no-console
      console.log('config.js: process.env.REACT_APP_BACKEND_URL =', fromEnv);
      // eslint-disable-next-line no-console
      console.log('config.js: window._env_ =', (typeof window !== 'undefined') ? window._env_ : undefined);
      // eslint-disable-next-line no-console
      console.log('config.js: resolved BASE_URL =', trimmed || '(empty)');
    } catch {}
    return trimmed;
  } catch {
    return '';
  }
};

const API_CONFIG = {
  BASE_URL: resolveBaseUrl(),
  TIMEOUT: 10000, // 10 seconds
  HEADERS: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Accept-Language': 'ar',
  }
};

export default API_CONFIG;
